@if (store.showNursingCare()) {
    <p-card>
        <p-tabs class="override" value="basicInformation">
            <p-tablist>
                <p-tab value="basicInformation">
                    <span>{{ 'folder.voucher.nursingCarePlan.basicInformation.title' | translate }}</span>
                    @if (this.formSummary.touched && !this.formSummary.valid) {
                        <i class="pi pi-exclamation-triangle text-danger ml-2"></i>
                    }
                </p-tab>
                <p-tab value="diagnoses">{{ 'folder.voucher.nursingCarePlan.diagnoses.title' | translate }}</p-tab>
                <p-tab value="assessments">{{ 'folder.voucher.nursingCarePlan.assessments.title' | translate }}</p-tab>
            </p-tablist>

            <p-tabpanels>
                <p-tabpanel value="basicInformation">
                    <div>
                        <div>
                            <a [routerLink]="['../']">
                                <i class="pi pi-link"></i>
                                {{ 'folder.voucher.nursingCarePlan.basicInformation.voucherLink' | translate }}
                            </a>
                        </div>
                        <div>
                            {{ 'folder.voucher.nursingCarePlan.basicInformation.diagnosisLink' | translate: { data: diagnosisLinkTitle } }}
                        </div>

                        <h5>{{ 'folder.voucher.nursingCarePlan.basicInformation.summaryHeader' | translate }}</h5>
                        <app-input-wysiwyg
                            [form]="formSummary"
                            id="summary"
                            [height]="300"
                            editorKey="NursingCareDetailSummary"
                            [autocompleteOrganization]="true"
                        ></app-input-wysiwyg>
                    </div>
                </p-tabpanel>
                <p-tabpanel value="diagnoses">
                    <div>
                        <app-table
                            #diagnosesTable
                            resource="folder"
                            [columns]="diagnosisColumns"
                            [gridData]="$any(store.data.nursingCareDiagnoses$ | async)"
                            translatePrefix="folder.voucher.nursingCarePlan.diagnoses."
                            [hideCheckboxes]="true"
                            [showButtonLabels]="true"
                            (deleteCallbackWithEvent)="deleteNursingCare($event)"
                            (detailCallback)="detailDiagnosis($event)"
                            (createCallback)="createDiagnosis()"
                            [refreshCallback]="store.api.getNursingCareDiagnoses"
                            [additionalFilter]="additionalFilterVoucherId"
                        ></app-table>
                    </div>
                </p-tabpanel>
                <p-tabpanel value="assessments">
                    <div>
                        <app-table
                            #assessmentsTable
                            resource="folder"
                            [columns]="assessmentColumns"
                            [gridData]="$any(store.data.nursingCareAssessments$ | async)"
                            translatePrefix="folder.voucher.nursingCarePlan.assessments."
                            [hideCheckboxes]="true"
                            [showButtonLabels]="true"
                            (deleteCallbackWithEvent)="deleteAssessment($event)"
                            (detailCallback)="detailAssessment($event)"
                            (createCallback)="createAssessment()"
                            [refreshCallback]="store.api.getNursingCareAssessments"
                            [additionalFilter]="additionalFilterVoucherId"
                        ></app-table>
                    </div>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </p-card>

    <app-error-float-message [(visible)]="invalidForm"
        message="database.vouchers.messages.invalidTab"
    ></app-error-float-message>

    <div class="mt-3">
        <app-action-buttons (primaryClickEvent)="submit()"
            (secondaryClickEvent)="cancel()"></app-action-buttons>
    </div>
}
